export const languageOptions = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  // Add more languages here if needed
];
